var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "10px",
    height: "20px",
    viewBox: "0 0 10 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Facebook") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-L",
    transform: "translate(-659.000000, -2441.000000)",
    fill: "#242424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(652.000000, 2441.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FACEBOOK"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1380585,20 L13.1380585,9.99882906 L15.8688768,9.99882906 L16.2307692,6.55237017 L13.1380585,6.55237017 L13.1426981,4.82738432 C13.1426981,3.92849476 13.2271783,3.4468492 14.5042409,3.4468492 L16.2114374,3.4468492 L16.2114374,0 L13.4802324,0 C10.1996159,0 9.04492402,1.67190336 9.04492402,4.48351906 L9.04492402,6.55276048 L7,6.55276048 L7,9.99921938 L9.04492402,9.99921938 L9.04492402,20 L13.1380585,20 Z",
    id: "Facebook"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c16e68ea080d0039900f63e679b30130.svg";
export { ForwardRef as ReactComponent };